module.exports = __webpack_public_path__ + "static/media/5 4 tattoo leg stag forest mountain majestic serene.1280x1720.8df9ebdc.webp";